import { Button, Icon, Menu, MenuItem } from "@blueprintjs/core";
import { Classes, Popover2 } from "@blueprintjs/popover2";
import React from "react";

export function Layer(editor) {
	const { Canvaseditor, disabledObj } = editor;

	// Canvas may not be ready immediately; guard all Fabric calls.
	const isCanvasReady =
		Canvaseditor && typeof Canvaseditor.getObjects === "function";

	const notifyModified = () => {
		if (!isCanvasReady) return;
		if (typeof Canvaseditor.fire === "function") Canvaseditor.fire("object:modified");
	};

	const moveObjectUp = () => {
		if (!isCanvasReady) return;
		let selectedObj = Canvaseditor.getActiveObject();
		if (selectedObj) {
			Canvaseditor.bringForward(selectedObj);
			Canvaseditor.renderAll();
			notifyModified();
		}
	};

	const moveObjectDown = () => {
		if (!isCanvasReady) return;
		let selectedObj = Canvaseditor.getActiveObject();
		if (selectedObj) {
			Canvaseditor.sendBackwards(selectedObj);
			Canvaseditor.renderAll();
			notifyModified();
		}
	};

	const moveObjectForward = () => {
		if (!isCanvasReady) return;
		let selectedObj = Canvaseditor.getActiveObject();
		if (selectedObj) {
			selectedObj.bringToFront();
			Canvaseditor.renderAll();
			notifyModified();
		}
	};

	const moveObjectBottom = () => {
		if (!isCanvasReady) return;
		let selectedObj = Canvaseditor.getActiveObject();
		if (selectedObj) {
			selectedObj.sendToBack();
			Canvaseditor.renderAll();
			notifyModified();
		}
	};

	return (
		<div className='position'>
			<Popover2
				interactionKind='click'
				popoverClassName={Classes.POPOVER2_CONTENT_SIZING}
				placement='bottom'
				content={
					<Menu>
						<MenuItem onClick={moveObjectUp} icon='arrow-up' text='Move Up' />
						<MenuItem
							onClick={moveObjectDown}
							icon='arrow-down'
							text='Move Down'
						/>
						<MenuItem
							onClick={moveObjectForward}
							icon='double-chevron-up'
							text='Move to Forward'
						/>
						<MenuItem
							onClick={moveObjectBottom}
							icon='double-chevron-down'
							text='Move to Bottom'
						/>
					</Menu>
				}
				renderTarget={({ isOpen, ref, ...targetProps }) => (
					<Button
						{...targetProps}
						elementRef={ref}
						disabled={disabledObj}
						icon={<Icon icon='move' />}
						text='Layers'
					/>
				)}
			/>
		</div>
	);
}
